<template>
  <v-footer padless class="mt-5">
    <v-row id="top-bar" justify="center" class="mx-0 py-3">
      <v-col md="10" lg="8">
        <a :href="privacyURL" target="_blank" class="pr-2">
          Privacy Policy
        </a>
        <a :href="contactURL" target="_blank" class="px-2">
          Contact
        </a>
        <a href="https://www.teleflex.com" target="_blank" class="pl-2">
          Teleflex.com
        </a>
      </v-col>
    </v-row>
    <v-row id="bottom-bar" justify="center" class="mx-0 py-2">
      <v-col
        xs="12"
        sm="8"
        lg="6"
        align-self="center"
        class="copyright white--text"
      >
        &copy; {{ currentYear }} Teleflex Incorporated. All Rights Reserved.
      </v-col>
      <v-col xs="12" sm="4" md="2" class="logo">
        <a href="https://www.teleflex.com">
          <img height="25rem" src="../assets/teleflex-logo.png" />
        </a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  props: {
    region: {
      type: Number,
      default: 1
    }
  },
  computed: {
    privacyURL() {
      switch (this.region) {
        case 1:
          return 'https://www.teleflex.com/emea/en/legal/internet-privacy-policy/index.html';
        default:
          return 'https://www.teleflex.com/emea/en/legal/internet-privacy-policy/index.html';
      }
    },
    contactURL() {
      switch (this.region) {
        case 1:
          return 'https://teleflex.com/emea/en/contact/europe-middle-east-africa/';
        default:
          return 'https://teleflex.com/emea/en/contact/europe-middle-east-africa/';
      }
    },
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
#top-bar {
  background-color: #878c93;
  position: relative;
  width: 100%;
}
.v-footer {
  background-color: #00205b !important;
  white-space: nowrap;
}
a {
  border-right: 1.5px solid #fff;
  color: #fff !important;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
a:last-child {
  border-right: 0;
}
#bottom-bar {
  position: relative;
  width: 100%;
}

@media only screen and (max-width: 380px) {
  .copyright {
    font-size: 0.9em;
  }
}
</style>
